import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { api } from 'api';
import { zones } from 'services/zones';
import { notify } from 'libs/common';
import { Button, themes, Dialog } from 'libs/ui';
import { ZoneSelect } from '../row/zone-select';
import { Content, ContentAdd, Table } from './counters-add.styled';

export const CountersAdd = (props) => {
  const { t } = useTranslation();
  const { refresh, currentArray, clientId } = props;
  const [working, setWorking] = useState(false);
  const [show, setShow] = useState(false);

  const zonesAll = zones.getZones();
  const current = zonesAll.filter((el) => !currentArray.includes(el.zone_id));
  const [value, setValue] = useState(current.length ? current[0].zone_id : '');

  const change = (event) => {
    setValue(event.target.value);
  };

  const add = () => {
    setShow(true);
  };

  const close = () => {
    setShow(false);
  };

  const save = () => {
    if (working) {
      return;
    }
    setWorking(true);

    api
      .call('client_counters.add', { client_id: clientId, zone_id: value })
      .then(() => {
        notify(t('sections.Счетчики клиентов'), t('messages.Сохранено успешно'), 'success');
        setWorking(false);
        refresh();
      })
      .catch((_error) => {
        notify(t('sections.Счетчики клиентов'), t('errors.Ошибка сохранения') /*+ error.toString()*/);
        setWorking(false);
      });
  };

  return (
    <Content>
      <Button theme={themes.gray} onClick={add} disabled={current.length === 0}>
        {t('buttons.Добавить')}
      </Button>

      {show && (
        <Dialog
          title={'Добавить счетчик'}
          buttons={[
            { title: t('buttons.Отменить'), onClick: close },
            { title: t('buttons.Сохранить'), onClick: save, theme: themes.blue, working },
          ]}
        >
          <ContentAdd>
            <Table>
              <thead>
                <tr>
                  <th>{t('tables.Парковочная зона')}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <ZoneSelect name="zone_id" value={value} onChange={change} current={current} />
                  </td>
                </tr>
              </tbody>
            </Table>

            {/* <Buttons>
          <Button theme={themes.blue} onClick={save} disabled={!valid}>
            <i className="fa fa-save" />
            {t('buttons.Сохранить')}
          </Button>
        </Buttons> */}
          </ContentAdd>
        </Dialog>
      )}
    </Content>
  );
};
